import {
    type PayloadAction,
    createSlice,
    createSelector,
} from '@reduxjs/toolkit';
import { RootState } from 'store';

type InitialInvestmentOverviewSlice = {
    isSavingWizardVisible: boolean
}

const initialState: InitialInvestmentOverviewSlice = {
    isSavingWizardVisible: false,

};

export const investmentOverviewSlice = createSlice({
    name: 'investmentOverview',
    initialState,
    reducers: {
        setIsSavingWizardVisible: (state, action: PayloadAction<boolean>) => ({
            ...state,
            isSavingWizardVisible: action.payload,
        }),
    },
});

export const selectInvestmentOverview = (state: RootState) => state.investmentOverview;

export const selectIsSavingWizardVisible = createSelector(
    selectInvestmentOverview,
    (investmentOverview:InitialInvestmentOverviewSlice) => investmentOverview.isSavingWizardVisible,
);

export const {
    setIsSavingWizardVisible,
} = investmentOverviewSlice.actions;
